module.exports = __webpack_public_path__ + "img/107756d.png";